import { consentCurrent } from '@akrababul/shared';
import { applySessionNav, type SessionInfo } from './nav.js';

/** Oturum yoksa giriş sayfasına yönlendirir ve hiç çözülmeyen bir promise döner (sayfa değişiyor). Menüyü de kurar. */
export async function requireSession(): Promise<SessionInfo> {
  const s = await applySessionNav();
  if (!s) { window.location.href = '/giris.html?next=' + encodeURIComponent(window.location.pathname); return new Promise(() => {}); }
  // Google ile açılan hesapta rıza kayıt anında alınamıyor; metin sürümü değişince de eskir.
  if (!consentCurrent(s)) { window.location.href = '/onay.html?next=' + encodeURIComponent(window.location.pathname); return new Promise(() => {}); }
  return s;
}

/** Zaten giriş yapmış kullanıcıyı kayıt/giriş sayfalarından uzaklaştırır. */
export async function redirectIfLoggedIn(to = '/akrabalarim.html'): Promise<void> {
  const s = await applySessionNav();
  if (s) window.location.href = to;
}
